<p>
  Your earnings are used to estimate your pension income under the Defined Benefit pension
  plan. The tool starts with the annualized pensionable earnings for the year you entered above
  and, using the salary growth assumption chosen by you, projects your earnings for future years.
  This assumption represents your <strong>average annual increase in base salary</strong> for each year to your
  retirement. In choosing this assumption, you should consider your salary growth rate today, as
  well as your expected future career path. When in doubt, it's best to be conservative so that the
  tool does not provide overly optimistic results.
</p>